interface ActionFooterProps {
  onCancel: () => void
  onBlastAds: () => void
  isBlasting: boolean
  summaryStats: {
    selectedAdSetsCount: number
    totalAdSets: number
    totalCampaigns: number
  }
}

export default function ActionFooter({
  onCancel,
  onBlastAds,
  isBlasting,
  summaryStats,
}: ActionFooterProps) {
  return (
    <div className="flex-shrink-0 p-6 border-t-2 border-system-blue-600">
      <div className="flex items-center justify-between">
        {/* Action Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-600 text-white rounded-xl hover:bg-gray-700 transition-colors font-medium text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onBlastAds}
            disabled={isBlasting}
            className="px-4 py-2 bg-brand text-white rounded-xl hover:bg-basic-pink-hover transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isBlasting ? "Blasting..." : "Blast Ads"}
          </button>
        </div>

        {/* Summary Section */}
        <div className="text-right">
          <p className="text-white text-sm">
            Blasting <span className="font-bold">1 ad</span> into{" "}
            <span className="font-bold">
              {summaryStats.selectedAdSetsCount} ad sets
            </span>
          </p>
          {summaryStats.totalCampaigns > 0 && (
            <p className="text-gray-400 text-xs mt-1">
              {summaryStats.totalCampaigns} campaigns available
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
